module.exports = __webpack_public_path__ + "static/media/students-smiling.6f5fac3a.jpeg";